import React from 'react';
import { Box, Typography } from '@mui/material';
import { GetApp } from '@mui/icons-material';
import { FormattedMessage } from 'intl';
import { IssueTranslationKeys } from 'intl/keys';

import CouldntPreviewIcon from 'assets/icons/file.svg?react';
import { ButtonContained } from 'components/general';
import { ROOT_SX, TITLE_SX } from './styles';
import { Props } from './types';

export const FilePreviewError: React.FC<Props> = ({ onDownload }) => {
  return (
    <Box sx={ROOT_SX}>
      <CouldntPreviewIcon />
      <Typography sx={TITLE_SX}>
        <FormattedMessage id={IssueTranslationKeys.previewGalleryCantPreviewMessage} />
      </Typography>
      <ButtonContained onClick={onDownload} startIcon={<GetApp />}>
        <FormattedMessage id={IssueTranslationKeys.previewGalleryFileDownloadLabel} />
      </ButtonContained>
    </Box>
  );
};
